import { extractApiErrorMessage } from './extract-api-error-message.util';

type ErrorTranslation = {
  pattern: RegExp;
  toFrench: (match: RegExpMatchArray) => string;
};

const VALIDATION_FAILED_PREFIX = /^(?:\w+ )?validation failed:\s*/i;

const ERROR_TRANSLATIONS: ErrorTranslation[] = [
  {
    pattern: /^(Product|Basket|Category|Sub-category) already archived$/,
    toFrench: () => 'Cet élément est déjà archivé',
  },
  {
    pattern: /^(Product|Basket|Category|Sub-category) is not archived$/,
    toFrench: () => "Cet élément n'est pas archivé",
  },
  {
    pattern: /^(Product|Basket) is archived$/,
    toFrench: () => "Cet élément est archivé : restaurez-le d'abord",
  },
  {
    pattern: /^Category is archived$/,
    toFrench: () => "Cette rubrique est archivée : restaurez-la d'abord",
  },
  {
    pattern: /^Sub-category is archived$/,
    toFrench: () => "Cette sous-rubrique est archivée : restaurez-la d'abord",
  },
  {
    pattern: /^Product is used by baskets: (.+)$/,
    toFrench: (match) => `Ce produit est utilisé par les paniers : ${match[1]}`,
  },
  {
    pattern: /^Sub-category is used by (\d+) products and (\d+) baskets$/,
    toFrench: (match) => `Cette sous-rubrique est utilisée par ${match[1]} produit(s) et ${match[2]} panier(s)`,
  },
  {
    pattern: /^Category is used by (\d+) sub-categories, (\d+) products and (\d+) baskets$/,
    toFrench: (match) =>
      `Cette rubrique est utilisée par ${match[1]} sous-rubrique(s), ${match[2]} produit(s) et ${match[3]} panier(s)`,
  },
  {
    pattern: /^Restore the sub-category first$/,
    toFrench: () => "Restaurez d'abord la sous-rubrique",
  },
  {
    pattern: /^Restore the category first$/,
    toFrench: () => "Restaurez d'abord la rubrique",
  },
  {
    pattern: /^Restore the products first: (.+)$/,
    toFrench: (match) => `Restaurez d'abord les produits : ${match[1]}`,
  },
  {
    pattern: /^Unknown tax$/,
    toFrench: () => 'Taxe inconnue',
  },
  {
    pattern: /^Unknown weight unity$/,
    toFrench: () => 'Unité de poids inconnue',
  },
  {
    pattern: /^Unknown sub-category$/,
    toFrench: () => 'Sous-rubrique inconnue',
  },
  {
    pattern: /^Unknown category$/,
    toFrench: () => 'Rubrique inconnue',
  },
  {
    pattern: /^Unknown products: (.+)$/,
    toFrench: (match) => `Produits inconnus : ${match[1]}`,
  },
  {
    pattern: /^Archived products: (.+)$/,
    toFrench: (match) => `Produits archivés : ${match[1]}`,
  },
  {
    pattern: /^Tax rate is frozen: used by (\d+) products or baskets$/,
    toFrench: (match) => `Taux gelé : la taxe est utilisée par ${match[1]} produit(s) ou panier(s)`,
  },
  {
    pattern: /^Tax is used by (\d+) products or baskets$/,
    toFrench: (match) => `La taxe est utilisée par ${match[1]} produit(s) ou panier(s)`,
  },
  {
    pattern: /^Tax name already used$/,
    toFrench: () => 'Ce nom de taxe existe déjà',
  },
  {
    pattern: /^Tag name already used$/,
    toFrench: () => 'Ce nom de tag existe déjà',
  },
  {
    pattern: /^Cannot deactivate yourself$/,
    toFrench: () => 'Vous ne pouvez pas désactiver votre propre compte',
  },
  {
    pattern: /^Cannot deactivate the last super admin$/,
    toFrench: () => 'Impossible de désactiver le dernier super administrateur',
  },
  {
    pattern: /^User has orders to deliver: (.+)$/,
    toFrench: (match) => `Ce client a des commandes à livrer : ${match[1]}`,
  },
  {
    pattern: /^User has invitations in progress: (\d+)$/,
    toFrench: (match) => `Cet éco-acteur a ${match[1]} invitation(s) en cours`,
  },
  {
    pattern: /^User is active$/,
    toFrench: () => 'Ce client est déjà actif',
  },
  {
    pattern: /^User is not active$/,
    toFrench: () => 'Ce client est désactivé',
  },
  {
    pattern: /^Only a super admin can grant the admin role$/,
    toFrench: () => 'Seul un super administrateur peut attribuer ce rôle',
  },
  {
    pattern: /^Only a super admin can modify a staff account$/,
    toFrench: () => 'Seul un super administrateur peut modifier ce compte',
  },
  {
    pattern: /^Cannot demote the last super admin$/,
    toFrench: () => 'Impossible de rétrograder le dernier super administrateur',
  },
  {
    pattern: /^Cannot change your own role$/,
    toFrench: () => 'Vous ne pouvez pas changer votre propre rôle',
  },
  {
    pattern: /^Email already used$/,
    toFrench: () => 'Cet email est déjà utilisé',
  },
  {
    pattern: /^User is not an eco actor$/,
    toFrench: () => "Ce client n'est pas éco-acteur",
  },
  {
    pattern: /^Email could not be sent$/,
    toFrench: () => "Le mail n'a pas pu être envoyé, le rôle est bien enregistré",
  },
  {
    pattern: /^Segment name already used$/,
    toFrench: () => 'Ce nom de segment existe déjà',
  },
  {
    pattern: /^Segment is used by delivery points: (.+)$/,
    toFrench: (match) => `Ce segment est utilisé par les points de livraison : ${match[1]}`,
  },
  {
    pattern: /^Segment already archived$/,
    toFrench: () => 'Ce segment est déjà archivé',
  },
  {
    pattern: /^Segment is not archived$/,
    toFrench: () => "Ce segment n'est pas archivé",
  },
  {
    pattern: /^Segment is archived$/,
    toFrench: () => 'Ce segment est archivé',
  },
  {
    pattern: /^Restore the segment first$/,
    toFrench: () => "Restaurez d'abord le segment",
  },
  {
    pattern: /^Delivery point already archived$/,
    toFrench: () => 'Ce point est déjà archivé',
  },
  {
    pattern: /^Delivery point is not archived$/,
    toFrench: () => "Ce point n'est pas archivé",
  },
  {
    pattern: /^Delivery point is archived$/,
    toFrench: () => 'Ce point est archivé',
  },
  {
    pattern: /^Company code is required$/,
    toFrench: () => 'Un point entreprise doit avoir un code',
  },
  {
    pattern: /^Discount is only allowed on company points$/,
    toFrench: () => 'La remise est réservée aux points entreprise',
  },
  {
    pattern: /^Delivery point code already used$/,
    toFrench: () => 'Ce code entreprise existe déjà',
  },
  {
    pattern: /^Delivery point is used by organizations: (.+)$/,
    toFrench: (match) => `Ce point est utilisé par les organisations : ${match[1]}`,
  },
  {
    pattern: /^Delivery point has orders to deliver: (.+)$/,
    toFrench: (match) => `Ce point a des commandes à livrer : ${match[1]}`,
  },
  {
    pattern: /^The store delivery point cannot be archived$/,
    toFrench: () => 'Le point de livraison du magasin ne peut pas être archivé',
  },
  {
    pattern: /^The store delivery point cannot be renamed or retyped$/,
    toFrench: () => 'Le point de livraison du magasin ne peut pas être modifié',
  },
  {
    pattern: /^The store delivery point already exists$/,
    toFrench: () => 'Le point de livraison du magasin existe déjà',
  },
  {
    pattern: /E11000 duplicate key error collection: \S+\.discounts index/,
    toFrench: () => "Ce bon d'achat existe déjà",
  },
  {
    pattern: /E11000 duplicate key/,
    toFrench: () => 'Cette valeur existe déjà',
  },
  {
    pattern: /Invalid tax amount/,
    toFrench: () => 'Montant de taxe invalide (ex. 5.5 ou 20)',
  },
  {
    pattern: /must contain at least (\d+) characters?/,
    toFrench: (match) => `Ce champ doit contenir au moins ${match[1]} caractères`,
  },
  {
    pattern: /is shorter than the minimum allowed length \((\d+)\)/,
    toFrench: (match) => `Ce champ doit contenir au moins ${match[1]} caractères`,
  },
  {
    pattern: /must contain at most (\d+) characters?/,
    toFrench: (match) => `Ce champ doit contenir au plus ${match[1]} caractères`,
  },
  {
    pattern: /is longer than the maximum allowed length \((\d+)\)/,
    toFrench: (match) => `Ce champ doit contenir au plus ${match[1]} caractères`,
  },
  {
    pattern: /^No active delivery city for this zip code$/,
    toFrench: () => 'Aucune ville de livraison active pour ce code postal',
  },
  {
    pattern: /^Delivery city zip code already used$/,
    toFrench: () => 'Ce code postal est déjà utilisé par une ville de livraison, archivée ou non',
  },
  {
    pattern: /^Delivery city already archived$/,
    toFrench: () => 'Cette ville est déjà archivée',
  },
  {
    pattern: /^Delivery city is not archived$/,
    toFrench: () => "Cette ville n'est pas archivée",
  },
  {
    pattern: /^Delivery city is archived$/,
    toFrench: () => 'Cette ville est archivée',
  },
  {
    pattern: /^Delivery city not found$/,
    toFrench: () => 'Ville de livraison introuvable',
  },
  {
    pattern: /^Restore the zone first$/,
    toFrench: () => "Restaurez d'abord la zone",
  },
  {
    pattern: /^Delivery zone name already used$/,
    toFrench: () => 'Ce nom de zone existe déjà',
  },
  {
    pattern: /^Delivery zone charges are required$/,
    toFrench: () => 'Les trois paliers de la zone sont obligatoires',
  },
  {
    pattern: /^Delivery zone is used by delivery cities: (.+)$/,
    toFrench: (match) => `Cette zone est utilisée par les villes : ${match[1]}`,
  },
  {
    pattern: /^Delivery zone already archived$/,
    toFrench: () => 'Cette zone est déjà archivée',
  },
  {
    pattern: /^Delivery zone is not archived$/,
    toFrench: () => "Cette zone n'est pas archivée",
  },
  {
    pattern: /^Delivery zone is archived$/,
    toFrench: () => 'Cette zone est archivée',
  },
  {
    pattern: /^Delivery zone not found$/,
    toFrench: () => 'Zone de livraison introuvable',
  },
  {
    pattern: /^Delivery point not found$/,
    toFrench: () => 'Point de livraison introuvable',
  },
  {
    pattern: /not found$/,
    toFrench: () => 'Introuvable',
  },
];

export function translateApiError(message: string): string {
  const normalizedMessage = message.replace(VALIDATION_FAILED_PREFIX, '');

  for (const { pattern, toFrench } of ERROR_TRANSLATIONS) {
    const match = pattern.exec(normalizedMessage);
    if (match) {
      return toFrench(match);
    }
  }
  return message;
}

export function extractTranslatedApiErrorMessage(error: unknown, fallback: string): string {
  return translateApiError(extractApiErrorMessage(error, fallback));
}
